const CardShapes = () => {
  return (
    <svg
      width='349'
      height='220'
      viewBox='0 0 349 220'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='0.9' filter='url(#filter0_f_1241_697)'>
        <path
          d='M281.114 177.782L269.548 137.918C268.809 135.368 269.748 132.632 271.9 131.06L325.556 91.93C327.847 90.2607 330.975 90.3029 333.223 92.0325L385.679 132.512C389.546 135.495 388.716 141.521 384.188 143.365L289.642 181.88C286.138 183.309 282.162 181.398 281.114 177.776V177.782Z'
          fill='url(#paint0_linear_1241_697)'
          fillOpacity='0.6'
        />
      </g>
      <g opacity='0.9' filter='url(#filter1_f_1241_697)'>
        <path
          d='M174.485 114.135L198.855 132.127C200.995 133.707 201.922 136.451 201.17 138.995L185.421 192.436C184.439 195.777 180.923 197.7 177.558 196.741L127.993 182.632C123.774 181.432 122.01 176.439 124.556 172.876L165.5 115.558C167.568 112.663 171.617 112.024 174.485 114.141V114.135Z'
          fill='url(#paint1_linear_1241_697)'
          fillOpacity='0.6'
        />
      </g>
      <g opacity='0.9' filter='url(#filter2_f_1241_697)'>
        <path
          d='M230.041 163.977L201.864 184.973C199.988 186.372 199.031 188.686 199.37 190.999L211.431 273.001H383.972L237.631 163.977C235.379 162.299 232.292 162.299 230.041 163.977Z'
          fill='url(#paint2_linear_1241_697)'
          fillOpacity='0.6'
        />
      </g>
      <g opacity='0.9' filter='url(#filter3_f_1241_697)'>
        <path
          d='M5 -9L157.587 104.558C159.044 105.647 160.907 106.052 162.691 105.677L207.06 96.2775C209.346 95.7936 211.178 94.0939 211.838 91.8498L241.4 -9H5Z'
          fill='url(#paint3_linear_1241_697)'
          fillOpacity='0.6'
        />
      </g>
      <g opacity='0.9' filter='url(#filter4_f_1241_697)'>
        <path
          d='M320.319 -9L246.981 49.7452C244.96 51.3605 244.124 54.0405 244.863 56.5148L252.192 81.1311C253.136 84.2951 256.35 86.2129 259.582 85.5353L393.151 57.6451V-9H320.319Z'
          fill='url(#paint4_linear_1241_697)'
          fillOpacity='0.6'
        />
      </g>
      <defs>
        <filter
          id='filter0_f_1241_697'
          x='264.299'
          y='85.7061'
          width='128.842'
          height='101.649'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur
            stdDeviation='2.5'
            result='effect1_foregroundBlur_1241_697'
          />
        </filter>
        <filter
          id='filter1_f_1241_697'
          x='118.375'
          y='107.892'
          width='88.0527'
          height='94.0967'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur
            stdDeviation='2.5'
            result='effect1_foregroundBlur_1241_697'
          />
        </filter>
        <filter
          id='filter2_f_1241_697'
          x='194.303'
          y='157.719'
          width='194.67'
          height='120.282'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur
            stdDeviation='2.5'
            result='effect1_foregroundBlur_1241_697'
          />
        </filter>
        <filter
          id='filter3_f_1241_697'
          x='0'
          y='-14'
          width='246.4'
          height='124.814'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur
            stdDeviation='2.5'
            result='effect1_foregroundBlur_1241_697'
          />
        </filter>
        <filter
          id='filter4_f_1241_697'
          x='239.598'
          y='-14'
          width='158.553'
          height='104.671'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur
            stdDeviation='2.5'
            result='effect1_foregroundBlur_1241_697'
          />
        </filter>
        <linearGradient
          id='paint0_linear_1241_697'
          x1='258.744'
          y1='130.471'
          x2='417.34'
          y2='115.52'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1241_697'
          x1='116.443'
          y1='149.379'
          x2='221.055'
          y2='142.32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1241_697'
          x1='182.901'
          y1='210.567'
          x2='427.903'
          y2='180.742'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_1241_697'
          x1='-15.9962'
          y1='40.815'
          x2='295.31'
          y2='-5.78347'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_1241_697'
          x1='231.404'
          y1='32.0755'
          x2='428.842'
          y2='9.5526'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CardShapes;
